// Make sure to prefix the mutation names with the module to avoid collisions
export const RESOURCE_SET_PAGE = 'resourceSetPage'
export const RESOURCE_SET_LINK = 'resourceSetLink'
export const RESOURCE_SET_RESOURCES ='resourceSetResources'
export const RESOURCE_SET_CATEGORIES ='resourceSetCategories'
export const RESOURCE_SET_DISABLED_RESOURCES ='resourceSetDisabledResources'
export const RESOURCE_CLOSE_CREATE_LINK_MODAL = 'resourceCloseCreateLinkModal'
export const RESOURCE_OPEN_CREATE_LINK_MODAL = 'resourceOpenCreateLinkModal'

export const RESOURCE_CLOSE_DELETE_LINK_MODAL = 'resourceCloseDeleteLinkModal'
export const RESOURCE_OPEN_DELETE_LINK_MODAL = 'resourceOpenDeleteLinkModal'

export const RESOURCE_OPEN_DISABLE_LINK_MODAL = 'resourceOpenDisableLinkModal'
export const RESOURCE_CLOSE_DISABLE_LINK_MODAL = 'resourceCloseDisableLinkModal'

export const RESOURCE_OPEN_ENABLE_LINK_MODAL = 'resourceOpenEnableLinkModal'
export const RESOURCE_CLOSE_ENABLE_LINK_MODAL = 'resourceCloseEnableLinkModal'

export const RESOURCE_OPEN_EDIT_LINK_MODAL = 'resourceOpenEditLinkModal'
export const RESOURCE_CLOSE_EDIT_LINK_MODAL = 'resourceCloseEditLinkModal'

export const RESOURCE_CLOSE_DELETE_PAGE_MODAL = 'resourceCloseDeletePageModal'
export const RESOURCE_OPEN_DELETE_PAGE_MODAL = 'resourceOpenDeletePageModal'

export const RESOURCE_OPEN_DISABLE_PAGE_MODAL = 'resourceOpenDisablePageModal'
export const RESOURCE_CLOSE_DISABLE_PAGE_MODAL = 'resourceCloseDisablePageModal'

export const RESOURCE_OPEN_ENABLE_PAGE_MODAL = 'resourceOpenEnablePageModal'
export const RESOURCE_CLOSE_ENABLE_PAGE_MODAL = 'resourceCloseEnablePageModal'